import { stringHash } from '../../../utils/string-hash';
import { type AvatarBackgroundColor, RANDOM_BACKGROUND_COLORS } from '../config';

/**
 * Get the background color for an avatar
 * If no background color is provided, it will be generated based on the name
 *
 */
export function getBackgroundColor(
  name: string,
  backgroundColor?: AvatarBackgroundColor
): AvatarBackgroundColor {
  if (backgroundColor !== undefined) {
    return backgroundColor;
  }

  const fallbackColor = RANDOM_BACKGROUND_COLORS[0];
  const colorFromName =
    RANDOM_BACKGROUND_COLORS[stringHash(name) % RANDOM_BACKGROUND_COLORS.length];

  return colorFromName ?? fallbackColor;
}
